const colors = {
	PRIMARY: "#f39c1c",
};

export default colors;
